module.exports = __webpack_public_path__ + "assets/cynai-logo-white.c0630941.svg";